import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { awsCloudTrailApiRef, AwsCloudTrailClient } from './api';

export const awsCloudTrailPlugin = createPlugin({
  id: 'aws-cloudtrail-monitor',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api:  awsCloudTrailApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AwsCloudTrailClient(discoveryApi, fetchApi),
    }),
  ],
});

export const AwsCloudTrailPage = awsCloudTrailPlugin.provide(
  createRoutableExtension({
    name:       'AwsCloudTrailPage',
    component:  () =>
      import('./components/CloudTrailPage').then(m => m.CloudTrailPage),
    mountPoint: rootRouteRef,
  }),
);
